<template>
  <div class="document" style="height: 100%">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Alias ID
          </div>
        </template>
      </es-header>
    </div>
    <es-exception
      v-if="!aliasIds.length"
      exceptionMessage="No Alias Ids for this Person."
      margin="3rem"
    />
    <div v-else class="table-wrapper">
      <table class="table is-fullwidth">
        <thead>
          <tr class="padding-left--small">
            <th title="Alias Id">
              Alias Id
            </th>
            <th title="Source System">
              {{ fieldLabel('SOURCE_CODE') }}
            </th>
            <th title="Person Type">
              Person Type
            </th>
            <th title="Status">
              Status
            </th>
          </tr>
        </thead>
        <template>
          <person-profile-alias-id-overview-row
            v-for="(aliasId, index) in filteredAliasIds"
            :key="index"
            :aliasId="aliasId"
          />
        </template>
    </table>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import { mapGetters } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import PersonProfileAliasIdOverviewRow from '@/components/PersonProfileAliasIdOverviewRow.vue';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faAngleDoubleRight,
);

export default {
  components: {
    PersonProfileAliasIdOverviewRow,
    EsException,
    EsHeader,
  },
  mixins: [
    FieldLabels,
  ],
  props: {
    aliasIds: {
      type: Array,
      required: true,
    },
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabelByPersonType',
    ]),

    filteredAliasIds() {
      return this.aliasIds.slice(0, 6);
    },
  },
  methods: {
    fieldLabel(code) {
      return this.getFieldLabelByPersonType(code, 'ASSIGN', this.person.personType);
    },
  },
};
</script>

<style lang="sass" scoped>
  .table-wrapper
    overflow-x: auto
</style>
